import { Grid, Tabs, Tab } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import TimelinePageStore from "../store/TimelinePageStore";

import { styled } from "@mui/material/styles";
import FilterButton from 'pages/AdviceTimelinePage/component/FilterButton';

const CustomTabs = styled(Tabs)`
  color: #ababab;

  .css-1a4240h-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #000000;
  }
`;

const CustomTab = styled(Tab)`
  color: #ababab;

  & .Mui-selected {
    color: #000000;
  }
`;

interface Props {
  pageStore: TimelinePageStore;
}

function TimeLineTopTabs(props: Props) {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log(newValue);
    props.pageStore.setTabValue(newValue);
    props.pageStore.fetchAsssessList(props.pageStore.userInfo.id);
    props.pageStore.setFilterValue("");
    props.pageStore.setFilterLikeDown(false);
    props.pageStore.setFilterLikeUp(false);
  };
  return (
    <Grid
      container
      item
      direction="column"
      rowGap={2}
      style={{ marginTop: "47px", marginBottom: "20px" }}
    >
      <CustomTabs
        value={props.pageStore.tabValue}
        onChange={handleChange}
        variant="fullWidth"
        aria-label="topTabs_Home"
        TabIndicatorProps={{
          sx: {
            background: "black",
          },
        }}
      >
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"downwards"}
          label="Downwards"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"peer"}
          label="Peer"
        />
        <CustomTab
          style={{
            textTransform: "none",
            fontFamily: "Pretendard",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "15px",
          }}
          value={"all"}
          label="All"
        />
      </CustomTabs>

    </Grid>
  );
}

export default observer(TimeLineTopTabs);
